import {
  STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING,
  STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING,
  STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING,
  STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN,
  STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN,
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_UPDATE_EXISTING_FAST_STOCK_LOADING_DATA_BEGIN

} from './constants'
import { deleteTranslationSaga } from "./deleteDictionaryTranslation/saga";
import { editDictionaryTranslationSaga } from './editDictionaryTranslation/saga';
import { getDictionaryOptionsSaga } from './getDictionaryOptions/saga';
import { getDictionaryCarlots } from './getDictionaryCarlots/saga';
import { saveTakingCarManagmentSaga } from './saveTakingCarManagment/saga';
import { getStateMachineSaga } from './getStateMachine/saga';
import { dispatchActionSaga } from './dispatchAction/saga';

import { takeEvery  } from "redux-saga/effects";
import { getTakingCarDetailsSaga } from './getTakingCarDetails/saga';
import { repeatTakingCarRequestSaga } from './repeatTakingCarRequest/saga';
import { getBrandsDataMasterSaga } from './getBrandsDataMaster/saga';
import { getModelsDataMasterSaga } from './getModelsDataMaster/saga';
import { getYearsDataMasterSaga } from './getYearsDataMaster/saga';
import { getVersionsDataMasterSaga } from './getVersionsDataMaster/saga';
import { getCarDetailDataMasterSaga } from './getCarDetailDataMaster/saga';
import { getCarLotsDataMasterSaga } from './getCarLotsDataMaster/saga';
import { getBranchOfficesDataMasterSaga } from './getBranchOfficesDataMaster/saga';
import { getLocationsDataMasterSaga } from './getLocationsDataMaster/saga';
import { getExchangeRatesDataMasterSaga } from './getExchangeRatesDataMaster/saga';
import { saveFastStockLoadingDataSaga } from './saveFastStockLoadingData/saga';
import { getSalesTypeCatalogsSaga } from './getSalesTypeCatalogs/saga';
import { getReferencePricesSaga } from './getReferencePrices/saga';
import { deleteTakingCarManagementSaga } from './deleteTakingCarManagement/saga';
import { updateExistingFastStockLoadingDataSaga } from './updateExistingFastStockLoadingData/saga';

// Watchers
export default function* stocks() {
    // Acá van todas las sagas del módulo Gestion Operativa
    yield takeEvery(STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING, deleteTranslationSaga);
    yield takeEvery(STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING, editDictionaryTranslationSaga);
    yield takeEvery(STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING, getDictionaryOptionsSaga);
    yield takeEvery(STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN, getDictionaryCarlots);
    yield takeEvery(STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN, saveTakingCarManagmentSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN, getStateMachineSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN, dispatchActionSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN, getTakingCarDetailsSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN, repeatTakingCarRequestSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_BRANDS_DATA_MASTER_BEGIN, getBrandsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN, getModelsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN, getYearsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN, getVersionsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN, getCarDetailDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN, getCarLotsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN, getBranchOfficesDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN, getLocationsDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN, getExchangeRatesDataMasterSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_BEGIN, saveFastStockLoadingDataSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_BEGIN, getSalesTypeCatalogsSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN, getReferencePricesSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_DELETE_STOCK_AND_CATALOG_BEGIN, deleteTakingCarManagementSaga);
    yield takeEvery(STOCK_TAKING_CAR_MANAGEMENT_UPDATE_EXISTING_FAST_STOCK_LOADING_DATA_BEGIN, updateExistingFastStockLoadingDataSaga);
  }